export default __webpack_public_path__ + "static/media/brand-laerdal-logo.4698633d.svg";